import React, { useEffect, useState } from 'react';
import { Box, Button, TextField, Typography, Modal, Switch, IconButton } from '@mui/material';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { ConstantActions, ManagementActions } from '../../../Services/_actions/index.js';
import { ProfileObject } from '../../../interfaces/Management.interface.ts';
import { useRecoilState, useRecoilValue } from 'recoil';
import { profileObjAtom } from '../../../Services/_states/Management/management.ts';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { userInformationAtom } from '../../../Services/_states/auth.js';
import ObjectLevelPermission from './ObjectLevelPermission.tsx';
import GeneralUserLevelPermission from './GeneralUserLevelPermission.tsx';
import DynamicBreadcrumbs from '../../Shared/Breadcrumb/index.tsx';
import HomeIcon from '@mui/icons-material/Home';


const Permissions: React.FC = () => {
  const profileObject= useRecoilValue<ProfileObject | any>(profileObjAtom);
  const navigate = useNavigate();
    const { mode } = useParams();
  

      const breadcrumbsData = mode === 'edit'
      ? [
          { label: <IconButton color='primary'><HomeIcon /></IconButton>, href: "/" },
          { label: 'Profile', href: '/r/management/profile-list' },
          { label: 'Permission Edit', href: '#', onClick: (event) => { navigate(-1) } },
        ]
      : [
          { label: <IconButton color='primary'><HomeIcon /></IconButton>, href: '/' },
          { label: 'Users', href: '/r/management/user-management' },
          { label: 'Permission View', href: '#', onClick: (event) => { navigate(-1) } },
        ];
    

   useEffect(() => {
    if (!profileObject?.id) {
    // if(!Object.keys(profileObject).length){
      navigate(-1); 
    }
  }, [profileObject, navigate]);


  return (
    <>
    <DynamicBreadcrumbs items={breadcrumbsData} onBreadcrumbClick={(event, item: { label: string, href: string }) => {
        if (item) {
          navigate(item?.href);
        }
      }}
      />
      <Box sx={{ pt: 1 }}>
        {profileObject?.object_level_permission?.length > 0 && <ObjectLevelPermission />}

      </Box>
      <Box sx={{ pt: 1 }}>
        {profileObject?.general_user_permission?.length > 0 && <GeneralUserLevelPermission />}
      </Box>
    </>
  );
};

export default Permissions;
